import { render, staticRenderFns } from "./index.vue?vue&type=template&id=af430252&scoped=true"
import script from "./index.vue?vue&type=script&setup=true&name=Organization&lang=js"
export * from "./index.vue?vue&type=script&setup=true&name=Organization&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=af430252&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af430252",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\workspace\\abroad-hrms-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('af430252')) {
      api.createRecord('af430252', component.options)
    } else {
      api.reload('af430252', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=af430252&scoped=true", function () {
      api.rerender('af430252', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/organization/index.vue"
export default component.exports